import angular from 'angular';
import appConfig from './app.config';
import appRun from './app.run';
import constants from './app.constants';
import dependenciesModule from './app.dependencies';
import sharedModule from './shared/shared';
import authModule from './auth/auth';
// import cartModule from './cart/cart';
// import CatalogModule from './catalog/catalog';
// import loginModule from './login/login';
// import homeModule from './home/home';
import payZoneModule from './pay-zone/pay-zone';
import tunnelModule from './tunnel/tunnel';
// import orders from './orders/orders';
import pqrsModule from './pqrs/pqrs';
import reportsModule from './reports/reports';
import templates from './templates/templates';
import paymentsAdvancesModule from './payments-advances/payments-advances';
// import fastPusrchase from './fast-purchase/fast-purchase';
import mainMenuModule from './main-menu/main-menu';
// import '../assets/css/vendors.styl'
// import usersModule from './users/users';
// import salesHome from './sales-home/sales-home';
// import registerModule from './register/register';
// import knowUsModule from './know-us/know-us';
// import dashboardModule from './dashboard/dashboard';
// import contactModule from './contact/contact';
import confirmationOrderModule from './confirmation-order/confirmation-order';
// import accountModule from './account/account';

// import footerModuleModule from './footer-modules/footer-modules';
// import headerModulesModule from './header-modules/header-modules';

import hodeAplicationModule from './home-aplication/home-aplication';
import b2bB2cAplicationModule from './b2b-b2c-aplication/b2b-b2c-aplication';

import ngInfiniteScroll from '../../node_modules/ng-infinite-scroll/build/ng-infinite-scroll';
import response from './response/response';
import shoppingExperienceModule from './shopping-experience/shopping-experience';
import pageModule from './page/page';
import metatagModule from "./metatag.service";

let casaBlancaModule = angular.module('hercules', [
    // knowUsModule.name,
    // accountModule.name,
    confirmationOrderModule.name,
    // dashboardModule.name,
    // contactModule.name,
    // registerModule.name,
    // salesHome.name,
    // usersModule.name,
    dependenciesModule.name,
    // loginModule.name,
    payZoneModule.name,
    sharedModule.name,
    tunnelModule.name,
    reportsModule.name,
    // CatalogModule.name,
    // homeModule.name,
    // orders.name,
    pqrsModule.name,
    authModule.name,
    templates.name,
    // cartModule.name,
    paymentsAdvancesModule.name,
    // fastPusrchase.name,
    mainMenuModule.name,
    // footerModuleModule.name,
    // headerModulesModule.name,
    hodeAplicationModule.name,
    b2bB2cAplicationModule.name,
    ngInfiniteScroll,
    response.name,
    shoppingExperienceModule.name,
    metatagModule.name,
    shoppingExperienceModule.name,
    pageModule.name
])
    .constant('ngAuthSettings', constants)
    .config(appConfig)
    .run(appRun);

export default casaBlancaModule;





// WEBPACK FOOTER //
// ./www/components/app.js